import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EnglishArabicDTO, FilterItem, FilterType, InputType, MultiLingualTextBoxOptions, PagingOptions, TextBoxOptions } from 'bbsf-controls';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { LookupGroupModel } from '../../shared/models/Lookups/LookupGroupModel';
import { UsersIDRequestModel } from '../../shared/models/UserModels/UsersIDRequestModel';
import { LookupGroupsService } from '../../shared/Services/LookupGroupsService.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bbsf-utilities';

@Component({
  selector: 'lib-lookup-group',
  templateUrl: './lookup-group.component.html'
})
export class LookupGroupComponent implements OnInit {
  SubheaderTitle = this.utilityService.getResourceValue('LookupGroups');
  

  ShowToolbar = true; ShowbreadCrumb = false;

  ApiUrl = "/api/admin/LookupGroup/"
  searchTextBox: TextBoxOptions;
  LookupGroupsForm = new FormGroup({});
  showFilter: boolean = false;
  LookupGroupsPagingResult: any[] = [];
  LookupGroupsPaging: PagingOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean;
  @ViewChild('LookupGroupPagingViewElement', { static: false }) input: ElementRef;


   //Add Model Controls
   AddLookupGroupForm = new FormGroup({});
   MultiLingualName:MultiLingualTextBoxOptions

   @ViewChild('CloseLookupGroupModal', { static: false }) CloseLookupGroupModal: ElementRef;


   //Edit Model Controls
  EditLookupGroupForm = new FormGroup({});
  EditMultiLingualName:MultiLingualTextBoxOptions
  LookupGroupId: number;
  @ViewChild('CloseEditLookupGroupModal', { static: false }) CloseEditLookupGroupModal: ElementRef;

  //delete  Model Controls
  deleteLookupGroupList: any[] = []
  @ViewChild('CloseDeleteLookupGroupModal', { static: false }) CloseDeleteLookupGroupModal: ElementRef;



  //Confirmation  Model Controls
  IsOpenConfirmationModal: boolean;
  ConfirmationModalType: number = 0;
  ConfirmationMessage: string = "";
  @ViewChild('CloseConfirmationModal', { static: false }) CloseConfirmationModal: ElementRef;

  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;
  ShowPageContent: boolean = false;

  language:string=""

  constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private LookupGroupsService: LookupGroupsService, private modalService: NgbModal)
  { 
  }

  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle = this.utilityService.getResourceValue("LookupGroups")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadList();
  }


  ReinitializePermissionsPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdatePermissionsPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setLookupGroupListResult(result) {
    this.LookupGroupsPagingResult = result;
    this.ShowPageContent = true;
    this.utilityService.stopBlockUI();

  }

  resetFilters() {
   this.LookupGroupsForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  LoadList() {

    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.HideLabel = true
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.LookupGroupsPaging = new PagingOptions();
      this.LookupGroupsPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetLookupGroupsByFilter';
      this.LookupGroupsPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.LookupGroupsPaging.Filters = [this.TextInputFilter]
      this.LookupGroupsPaging.ValidationToken = this.authService.authorizationHeaderValue()

      setTimeout(() => {
        this.IsFilterLoaded = true;
      }, 10);
    
  }

  showAddLookupGroupModal(AddLookupGroupModal) {
    this.utilityService.startBlockUI();
    this.AddLookupGroupForm = new FormGroup({});

  
    this.MultiLingualName = new MultiLingualTextBoxOptions();
    this.MultiLingualName.Name = "Name";
    this.MultiLingualName.ArabicLabelKey = "NameInArabic";
    this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.MultiLingualName.IsRequired = true;
    this.MultiLingualName.Value = null;

    this.modalService.open(AddLookupGroupModal);
    this.utilityService.stopBlockUI();
  }

  addLookupGroup() {
    if (this.AddLookupGroupForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddLookupGroupForm.value;
      let AddLookupGroupModel:LookupGroupModel= new LookupGroupModel() ;
      AddLookupGroupModel.Name.Arabic = ResultModel.Name.ArabicValue;
      AddLookupGroupModel.Name.English = ResultModel.Name.EnglishValue;
      this.LookupGroupsService.AddLookupGroup(AddLookupGroupModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
        
      })
    }
  }


  showEditLookupGroupModal(LookupGroup: any,EditLookupGroupModal) {

    this.utilityService.startBlockUI();
    this.EditLookupGroupForm = new FormGroup({});

    let Name=new EnglishArabicDTO();
    Name.Arabic=LookupGroup.name.arabic;
    Name.English=LookupGroup.name.english;

    this.EditMultiLingualName = new MultiLingualTextBoxOptions();
    this.EditMultiLingualName.Name = "EditName";
    this.EditMultiLingualName.ArabicLabelKey = "NameInArabic";
    this.EditMultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.EditMultiLingualName.IsRequired = true;
    this.EditMultiLingualName.Value = Name;

    this.LookupGroupId = LookupGroup.id

    this.modalService.open(EditLookupGroupModal);
    this.utilityService.stopBlockUI();

  }

  editLookupGroup() {
    if (this.EditLookupGroupForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditLookupGroupForm.value;
      let EditLookupGroupModel = new LookupGroupModel();
      EditLookupGroupModel.Id = this.LookupGroupId;
      EditLookupGroupModel.Name.English = ResultModel.EditName.EnglishValue;
      EditLookupGroupModel.Name.Arabic = ResultModel.EditName.ArabicValue;
      this.LookupGroupsService.EditLookupGroup(EditLookupGroupModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
      })
    }
  }


  showDeleteLookupGroupModal(LookupGroup: any, DeleteLookupGroupModal) {
    this.utilityService.startBlockUI();
    this.deleteLookupGroupList = []
    this.deleteLookupGroupList.push(LookupGroup);
    this.modalService.open(DeleteLookupGroupModal);
    this.utilityService.stopBlockUI();

  }

  deleteLookupGroup() {
    let  UsersIDModel:UsersIDRequestModel= new UsersIDRequestModel() ;
     for (let index = 0; index < this.deleteLookupGroupList.length; index++) {
       const element = this.deleteLookupGroupList[index];
       UsersIDModel.UsersIDs.push(element.id)
       
     }
    this.LookupGroupsService.DeleteLookupGroup(UsersIDModel ).subscribe((result) => {
      this.deleteLookupGroupList = [];
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
    })

  }




}
